import { Helmet } from 'react-helmet-async';

const StructuredData = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "JC Productions",
    "alternateName": "Videoagentur Aachen",
    "url": "https://jc-productions.de",
    "logo": "https://jc-productions.de/favicon.png",
    "description": "Professionelle Videoproduktion, Imagefilme und günstige Webseiten in Aachen. KI-Videos & klassische Produktionen.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Aachen",
      "addressRegion": "NRW",
      "addressCountry": "DE"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": ["German", "English"]
    },
    "sameAs": []
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "JC Productions - Videoproduktion & Webseitenagentur Aachen",
    "image": "https://jc-productions.de/favicon.png",
    "description": "Videoagentur & Webseitenagentur in Aachen. Professionelle Imagefilme, Videoproduktion & günstige Webseiten ab 1.490€.",
    "@id": "https://jc-productions.de",
    "url": "https://jc-productions.de",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Aachen",
      "addressRegion": "Nordrhein-Westfalen",
      "addressCountry": "DE"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 50.7753,
      "longitude": 6.0839
    },
    "priceRange": "€€",
    "areaServed": [
      {
        "@type": "City",
        "name": "Aachen"
      },
      {
        "@type": "State",
        "name": "Nordrhein-Westfalen"
      }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Videoproduktion & Webdesign Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Imagefilm Produktion",
            "description": "Professionelle Imagefilme für Unternehmen in Aachen"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Videoproduktion",
            "description": "Klassische und KI-gestützte Videoproduktion"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Webseiten Erstellung",
            "description": "Günstige professionelle Webseiten ab 1.490€"
          }
        }
      ]
    }
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "JC Productions",
    "url": "https://jc-productions.de",
    "description": "Videoproduktion & Webseitenagentur Aachen",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://jc-productions.de/?s={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  const navigationSchema = {
    "@context": "https://schema.org",
    "@type": "SiteNavigationElement",
    "name": "Hauptnavigation",
    "hasPart": [
      {
        "@type": "SiteNavigationElement",
        "name": "Videoproduktionen",
        "description": "Professionelle Videoproduktion in Aachen",
        "url": "https://jc-productions.de/"
      },
      {
        "@type": "SiteNavigationElement",
        "name": "Webseiten ab 1490€",
        "description": "Günstige professionelle Webseiten in 7 Tagen",
        "url": "https://web.aivinity.de"
      },
      {
        "@type": "SiteNavigationElement",
        "name": "Klassische Videoproduktion",
        "description": "Imagefilme und Testimonials mit Drehtag",
        "url": "https://jc-productions.de/leistungen/klassisch"
      },
      {
        "@type": "SiteNavigationElement",
        "name": "KI Produktionen",
        "description": "KI-Videos ohne Drehtag und Betriebsunterbrechung",
        "url": "https://jc-productions.de/leistungen/ki-produktionen"
      },
      {
        "@type": "SiteNavigationElement",
        "name": "Über uns",
        "description": "Lernen Sie unser Team kennen",
        "url": "https://jc-productions.de/ueber-uns"
      },
      {
        "@type": "SiteNavigationElement",
        "name": "FAQ",
        "description": "Häufig gestellte Fragen",
        "url": "https://jc-productions.de/faq"
      },
      {
        "@type": "SiteNavigationElement",
        "name": "Termin buchen",
        "description": "Kostenloses Beratungsgespräch vereinbaren",
        "url": "https://jc-productions.de/termin"
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(navigationSchema)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
